import React, {useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import FormatTimeStr from "../../helpers/FormatTimeStr";
import InterfaceBooking from "../../interface/InterfaceBooking";
import {SVVInformationMessage} from "@komponentkassen/svv-information-message";
import api from "../../helpers/api";
import {useApptekster} from "../../apptekst-context";
import {SVVDefinitionList, SVVDefinitionListItem} from "@komponentkassen/svv-definition-list";
import {SVVHeading} from "@komponentkassen/svv-text";
import {SVVButton, SVVButtonCustom, SVVButtonRow} from "@komponentkassen/svv-button";

const CancelConfirmation = (props: {
  booking: InterfaceBooking;
  setUnreserved: any;
  unreserved: boolean;
}) => {
  const t = useApptekster();
  const [fetchingError, setFetchingError] = useState<boolean>(false);
  const headingRef = useRef<HTMLHeadingElement | null>(null)

  useEffect(() => {
    if (headingRef?.current) {
      headingRef.current.focus()
    }
  }, [headingRef])

  const submit = (event: any) => {
    event.preventDefault();
    setFetchingError(false);

    api
      .get(
        `/api/Timebestilling/booking/cancel?bookingId=${props.booking.bookingId}`
      )
      .then((response) => {
        if (response?.status === 200) {
          props.setUnreserved(true);
        } else {
          setFetchingError(true);
          return false;
        }
      })
      .catch((error) => {
        // handle error
        setFetchingError(true);
        console.log(error);
      });
  };

  return (
    <>
      {props.unreserved && (
        <>
          <SVVHeading
            level="h2"
            ref={headingRef}
            tabIndex={-1}
          >
            {t("timebestilling.avbestilt-timen")}
          </SVVHeading>
          <div className="abstract Aligner">
            <span className="checkmark">
              <div className="checkmark_circle"></div>
              <div className="checkmark_stem"></div>
              <div className="checkmark_kick"></div>
            </span>&nbsp;
            <span>{t("timebestilling.din-time-avbestilt")}</span>
          </div>
        </>
      )}

      <SVVHeading
        level="h2"
        ref={headingRef}
        tabIndex={-1}
      >
        {t("timebestilling.du-avbestiller")}
      </SVVHeading>
      
      <SVVDefinitionList>
        <SVVDefinitionListItem 
          term={t("timebestilling.tjeneste")}
        >
          {props.booking.serviceName}
        </SVVDefinitionListItem>
        <SVVDefinitionListItem 
          term={t("timebestilling.trafikkstasjon")}
        >
          {props.booking.sectionName}
        </SVVDefinitionListItem>
        <SVVDefinitionListItem 
          term={t("timebestilling.trafikkstasjon-og-tidspunkt")}
        >
          {props.booking.sectionName} - {props.booking.bookedDateTime ? FormatTimeStr(props.booking.bookedDateTime) : t("timebestilling.klokkeslett-mangler")}
        </SVVDefinitionListItem>
        <SVVDefinitionListItem 
          term={t("timebestilling.referansenummer")}
        >
          <span data-hj-suppress>
            {props.booking.bookingNumber}
          </span>
        </SVVDefinitionListItem>
      </SVVDefinitionList>
      <div className="svv-padding-top--px32">
        {fetchingError &&
            <SVVInformationMessage type="error" className="abstract">
              <p>
                {t("timebestilling.tekniskfeil-ikke-avbestilt")}
              </p>
            </SVVInformationMessage>
        }
        
        {!props.unreserved &&
          <SVVButtonRow>
            <SVVButton onClick={submit}>
              {t("timebestilling.avbestill-timen")}
            </SVVButton>
            <SVVButtonCustom 
              asElement={Link}
              href="/"
              hrefAttribute="to"
              color="secondary"
            >
              {t("timebestilling.avbryt")}
            </SVVButtonCustom>
          </SVVButtonRow>
        }
        {props.unreserved &&
          <SVVButtonCustom 
            asElement={Link}
            href="/"
            hrefAttribute="to"
          >
            {t("timebestilling.tilbake")}
          </SVVButtonCustom>
        }
      </div>
    </>
  );
};

export default CancelConfirmation;